import Vue from 'vue'

import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n

import 'normalize.css/normalize.css'// A modern alternative to CSS resets


import VCharts from 'v-charts'

import '@/styles/index.scss' // global css

import App from './App'


import '@/icons' // icon
import VueClipboard from 'vue-clipboard2'
import '@/permission' // permission control
import Print from 'vue-print-nb'

import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import moment from 'moment-timezone'
import vueXlsxTable from 'vue-xlsx-table'
import VueI18n from 'vue-i18n'
//main.js中
// import './utils/flexible'

Vue.use(VueI18n) // 通过插件的形式挂载

Vue.use(ElementUI)
Vue.use(VCharts)
Vue.use(Print);
Vue.use(VueClipboard);
Vue.use(vueXlsxTable, { rABS: false })

Vue.config.productionTip = false
//全局注册指令----回车事件下一个input获取焦点
Vue.directive("focusNextOnEnter", {
  bind: function (el, { value }, vnode) {
    el.addEventListener("keyup", ev => {
      if (ev.keyCode === 13) {
        let nextInput = vnode.context.$refs[value];
        if (nextInput && typeof nextInput.focus === "function") {
          nextInput.focus();
          nextInput.select();
        }
      }
    });
  }
});

const i18n = new VueI18n({
  locale: 'zh-CN',    // 语言标识
  //this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages: {
    'zh-CN': require('./common/lang/zh'),   // 中文语言包
    'en-US': require('./common/lang/en')    // 英文语言包
  }
})

new Vue({
  el: '#app',
  i18n,
  router,
  store,
  template: '<App/>',
  components: { App }
})

//定义一个全局过滤器实现日期格式化
Vue.filter('datefmt', function (input, fmtstring) {
  if (input == null || input == '') {
    return 'NA'
  }
  // 使用momentjs这个日期格式化类库实现日期的格式化功能
  moment.tz.setDefault("Australia/Sydney");
  // moment.tz.set
  return moment(input).format(fmtstring);
});



// WEBPACK FOOTER //
// ./src/main.js